import Pqp from "../3x1010/Pqp.js";
import Main from "./Main.js";
import MappaHud from "./MappaHud.js";
import Scene from "./Scene.js";
export default class Radar {
	constructor(userLang, callback) {
		this.userLang = userLang;
		this.callback = callback;
		this.btn = undefined;
		this.mc = undefined;
		this.destroyed = false;
	}

	

	destroy() {
		this.destroyed = true;
		TweenMax.to(jQuery(".js-map", this.mc), 0.5, { css: { opacity: 0 }, onComplete: jQuery.proxy(this.mapHidden, this) });
	}

	mapHidden() {
		this.mc.remove();
		this.init();
	}

	reset(lInstant) {
		if (lInstant) {
			this.mapHidden();
		} else {

			this.destroy();
			this.destroyed = false;
			//	this.init();
		}
	}

	init() {
		let mc = jQuery("#template-trix-radar").clone();
		mc.attr("id", "bmappra" + Radar.ENUM++);
		jQuery(".js-trix1010").append(mc);
		this.mc = mc;
		mc.on("click", jQuery.proxy(this.openMap, this));

		/*let mappa = jQuery("#template-trix-map-hud").clone();
		mappa.attr("id", "bmapphua" + Radar.ENUM++);
		mc.append(mappa);*/


		this.placeDots();
		requestAnimationFrame(jQuery.proxy(this.update, this));

		jQuery(".js-map", this.mc).css("opacity", 0)
		TweenMax.to(jQuery(".js-map", this.mc), 0.5, { delay: 0.1, css: { opacity: 1 } });

	}

	openMap(lFlag) {
		Main.that.mappaHud.showMap();
	}

	show(lFlag) {
		if (lFlag) {
			this.mc.show();
		} else {
			this.mc.hide();
		}

	}


	update() {
		if (!this.destroyed) {
			this.orientaIndicatore();
			requestAnimationFrame(jQuery.proxy(this.update, this));
		}
	}


	placeDots() {
		let attuale = Scene.getCurrentScene();
		// Piazza gli hotspot
		let a = SceneList.SCENE;
		let lHigh = false;
		let toAppend = new Array();
		let toHigh = new Array();
		let row = 0;
		let col = 0;

		for (let x = 0; x < a.length; x++) {
			// Patcha le posizioni ancora non piazzate
			if (a[x].top == "-1") {
				a[x].patchPosx = (col * (5) + 1) + "%"
				a[x].patchPosy = (row * (5) + 5) + "%"

				col++;
				if (col > 20) {
					col = 0;
					row++;
				}
			}
		}



		for (let x = 0; x < a.length; x++) {
			//if (a[x].showOnMap) {

			let hs = jQuery("#template-trix-hothud").clone();
			hs.attr("id", "huhs" + MappaHud.ENUM++);
			//jQuery(".js-panel-hud", mc).append(hs);
			jQuery(".js-map", this.mc).append(hs);
			if (a[x].patchPosx) {
				hs.css({
					top: a[x].patchPosy,
					left: a[x].patchPosx
				});

			} else {
				hs.css({
					top: this.patchaPercTop(a[x].top),
					left: this.patchaPercLeft(a[x].left)
				});
			}

			// Cerca la caption adeguata
			let caption = a[x].caption;
			if (!a[x].showOnMap) {
				// cerca la caption di quello mostrato
				for (let p = 0; p < a.length; p++) {
					if (a[p].area == attuale.area) {
						if (a[p].showOnMap) {
							caption = a[p].caption;
							break;
						}
					}
				}
			}

			if (a[x].showOnMap) { // PQPDATOGLIERE
				jQuery(".js-caption", hs).html(caption);
			} else { // PQPDATOGLIERE
				jQuery(".js-caption", hs).html(""); // PQPDATOGLIERE
			} // PQPDATOGLIERE
			jQuery(".js-orienta", hs).hide();

			hs.on("click", jQuery.proxy(this.dismiss, this, {
				scene: a[x].spot
			}));
			if (a[x].area == attuale.area) {
				toHigh.push({
					spot: a[x].spot,
					mc: hs,
					data: a[x],
					show: a[x].showOnMap
				});
			} else {
				if (!a[x].showOnMap) {// PQPDATOGLIERE 
					hs.hide();
				}// PQPDATOGLIERE 
			}

		}
		//}

		// Controlla l'highlight
		let lFound = false;
		let norienta = 0;
		for (let x = 0; x < toHigh.length; x++) {
			//console.log(toHigh[x].spot + " " + attuale.spot)
			if (toHigh[x].spot == attuale.spot) {
				toHigh[x].mc.addClass("trix-hothud-selected");
				lFound = true;
				norienta = x;
			} else {
				if (!toHigh[x].show) {
					toHigh[x].mc.hide();
				}
			}
		}
		if (!lFound) {
			if (toHigh.length > 0) {
				toHigh[0].mc.addClass("trix-hothud-selected");
			}
		}
		toHigh[norienta].mc.css("z-index", 10000);
		this.indicatoremc = toHigh[norienta].mc
		this.objDataIndicatore = toHigh[norienta];
		this.orientaIndicatore();
		setTimeout(jQuery.proxy(this.centraMappa, this), 100);

	}

	patchaPercTop(top) {
		let tmp = parseFloat(top.split("%")[0]);
		//tmp -= 2.5;
		return tmp + "%";
	}
	patchaPercLeft(left) {
		let tmp = parseFloat(left.split("%")[0]);
		//tmp -= 1.7;
		return tmp + "%";

	}

	showIndicatore(indicatore) {
		indicatore.css("opacity", 1)
		this.stopUpdate = false;
	}


	orientaIndicatore() {
		if (this.stopUpdate) {
			return
		}
		let mc = this.indicatoremc;
		let o = this.objDataIndicatore;
		let indicatore = jQuery(".js-orienta", mc)
		indicatore.show();
		indicatore.css("opacity", 0);
		if (this.currentRoom != Scene.getCurrentScene().spot) {
			this.currentRoom = Scene.getCurrentScene().spot;
			setTimeout(this.showIndicatore.bind(this, indicatore), 500);
			this.stopUpdate = true;
			return
		} else {
			indicatore.css("opacity", 1);
		}
		
		//let original = Main.that.getOrientamentoBySceneName("scene0");
		let original = { prealign: "0|0|0" };//this.getOrientamentoBySceneName("scene0");
		let current = Main.that.getOrientamentoBySceneName(Scene.getCurrentScene().name);
		let spanOriginal = parseFloat(original.prealign.split("|")[1]);
		let spanCurrent = parseFloat(current.prealign.split("|")[1]);
		//console.log("-----------")	

		let dif = spanOriginal - spanCurrent;
		//console.log("Dif: " + dif);
		//console.log(spanOriginal, spanCurrent);
		let view = Main.that.pano.get("view");
		let curAngle = view.hlookat
		let adjust = Math.floor(Math.abs(view.hlookat / 360));

		if (curAngle < 0) {
			curAngle += adjust * 360;
		} else {
			curAngle -= adjust * 360;
		}

		/*
		console.log(view.hlookat);
		console.log(adjust)
		console.log(curAngle);
		*/

		//let endAngle = dif - curAngle + 90

		//endAngle = curAngle;
		let sfaso = PLUNGE_SETTINGS.customs.angle_span;
		if (!Pqp.isNullOrEmpty(o.data.adjustAngle)) {
			sfaso = o.data.adjustAngle;
		}

		let value = curAngle
		value += sfaso;
		//value += PLUNGE_SETTINGS.customs.angle_span;
		value -= dif;
		indicatore.css("transform", "rotate(" + value + "deg)");


	};

	centraMappa() {
		let coord = this.indicatoremc.position();
		//console.log(coord);
		//console.log();
		let sh = Math.floor(this.mc.height() / 2);
		let sw = Math.floor(this.mc.width() / 2);

		let mcw = Math.floor(this.indicatoremc.width() / 2);
		let mch = Math.floor(this.indicatoremc.height() / 2);

		jQuery(".js-map").css("left", -coord.left - mcw + sw);
		jQuery(".js-map").css("top", -coord.top - mch + sh);

	};

}
Radar.ENUM = 0;